import * as amplitude from "@amplitude/unified";

let initialized = false;

export function initAmplitude() {
  if (initialized) return;
  if (typeof window === "undefined") return;

  const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;

  if (!apiKey) {
    console.warn("Amplitude API key missing");
    return;
  }

  amplitude.initAll(apiKey, {
    analytics: {
      autocapture: false,
    },
    sessionReplay: {
      sampleRate: 1,
    },
  });

  initialized = true;
  console.log("Amplitude initialized");
}

export function trackEvent(eventName, eventProperties = {}) {
  amplitude.track(eventName, eventProperties);
}

export function setAmplitudeUser(user) {
  if (typeof window === "undefined" || !user) return;

  if (user.uid) {
    amplitude.setUserId(user.uid);
  }

  const identify = new amplitude.Identify();
  identify.set("display_name", user.displayName || null);
  identify.set("email_verified", !!user.emailVerified);
  identify.set("provider_id", user.providerId || null);
  identify.set("first_name", user.firstName || null);
  identify.set("last_name", user.lastName || null);
  identify.set("created_at", user.createdAt || null);
  identify.set("updated_at", user.updatedAt || null);

  amplitude.identify(identify);
}

export function clearAmplitudeUser() {
  if (typeof window === "undefined") return;
  amplitude.reset();
}

export function updatePurchaseUserProperties({ itemsCount = 0 } = {}) {
  if (typeof window === "undefined") return;

  const identify = new amplitude.Identify();

  identify.setOnce("hasPurchase", true);
  identify.add("orderCount", 1);
  identify.add("productPurchaseCount", Number(itemsCount || 0));
  identify.setOnce("firstPurchaseDate", new Date().toISOString());

  amplitude.identify(identify);
}

export { amplitude };